export default "__VITE_ASSET__DFl63Ax0__"